import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardCachingService {

  private cardId = new ReplaySubject<string>(1)

  set mCardId$(mCardId: string) {
    this.cardId.next(mCardId);
  }

  get mCardId$(): Observable<string | undefined> {
    return this.cardId.asObservable()
  }
}
